import { useTranslation } from 'react-i18next';
import { FileText } from 'lucide-react';
import { GuideSection } from '../components/GuideSection';
import { GuideSubSection } from '../components/GuideSubSection';
import { RoleHint } from '../components/RoleHint';

export function TicketDetailSection() {
  const { t } = useTranslation('help');
  const s = 'sections.ticketDetail';

  return (
    <GuideSection
      id="ticket-detail"
      title={t(`${s}.title`)}
      description={t(`${s}.description`)}
      icon={FileText}
    >
      <GuideSubSection title={t(`${s}.dmpData.title`)}>
        <p>{t(`${s}.dmpData.p1`)}</p>
        <p>{t(`${s}.dmpData.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.addressData.title`)}>
        <p>{t(`${s}.addressData.p1`)}</p>
        <p>{t(`${s}.addressData.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.buildArea.title`)}>
        <p>{t(`${s}.buildArea.p1`)}</p>
        <p>{t(`${s}.buildArea.p2`)}</p>
        <p>{t(`${s}.buildArea.relatedAddresses`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.timeline.title`)}>
        <p>{t(`${s}.timeline.p1`)}</p>
        <p>{t(`${s}.timeline.p2`)}</p>
        <RoleHint variant="external">{t(`${s}.timeline.externalHint`)}</RoleHint>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.comments.title`)}>
        <p>{t(`${s}.comments.p1`)}</p>
        <p>{t(`${s}.comments.mentions`)}</p>
        <p>{t(`${s}.comments.postAndResolve`)}</p>
        <div>
          <h4 className="text-xs font-bold text-slate-700 uppercase tracking-wide mb-1">
            {t(`${s}.comments.internalNotes`)}
          </h4>
          <p>{t(`${s}.comments.internalNotesDesc`)}</p>
        </div>
        <RoleHint variant="internal">{t(`${s}.comments.internalNotesHint`)}</RoleHint>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.attachments.title`)}>
        <p>{t(`${s}.attachments.p1`)}</p>
        <p>{t(`${s}.attachments.p2`)}</p>
        <p>{t(`${s}.attachments.p3`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.watchers.title`)}>
        <p>{t(`${s}.watchers.p1`)}</p>
        <p>{t(`${s}.watchers.p2`)}</p>
        <RoleHint variant="external">{t(`${s}.watchers.externalHint`)}</RoleHint>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.statusChanges.title`)}>
        <p>{t(`${s}.statusChanges.p1`)}</p>
        <p>{t(`${s}.statusChanges.p2`)}</p>
        <p>{t(`${s}.statusChanges.p3`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.escalation.title`)}>
        <p>{t(`${s}.escalation.p1`)}</p>
        <p>{t(`${s}.escalation.p2`)}</p>
      </GuideSubSection>
    </GuideSection>
  );
}
